import { zfUtils } from "./zf_utils";
import { zfc } from "./zfc_global";
import { zfcgac } from "./zfc_gallery";
export class zfctn {
    static init() {
        try {
            $(".zfctn-tile-wrapper").each(function () {
                var tileWrapper = $(this);
                var tileNavigation = tileWrapper.closest(".zfctn-tile-navigation");
                var stage = tileNavigation.find(".zfctn-stage");
                var tileItems = tileWrapper.children().length;
                var tileVersion = tileItems;
                var specialCase = false;
                var buttonWrapper = tileNavigation.find(".zfctn-button-wrapper");
                var button = buttonWrapper.find(".zfcui-btn");
                var resultList = tileNavigation.find(".zfctn-tile-results");
                tileVersion = 3;
                tileWrapper.addClass("zfctn-tile-items-v" + tileVersion);
                if (specialCase) {
                    tileWrapper.addClass("zfctn-tile-specialcase");
                }
                zfc.keyboardEnterToClick($(this).closest(".zfctn-tile-navigation").find(".zfctn-button-wrapper .zfcui-btn"));
                tileNavigation
                    .find(".zfctn-button-wrapper .zfcui-btn")
                    .off("click.zfctn")
                    .on("click.zfctn", function () {
                    var thatParent = $(this).parent();
                    var selection = [];
                    if (thatParent.hasClass("zfcui-btn-disabled")) {
                        return;
                    }
                    tileNavigation.find(".zfctn-tile-item.zfctn-item-active").each(function () {
                        selection.push($(this).data("target"));
                    });
                    resultList.find("[data-filter]").each(function () {
                        if (!$(this).hasClass("zfctn-hide-item")) {
                            $(this).addClass("zfctn-hide-item");
                        }
                        if ($(this).hasClass("zfctn-show-item")) {
                            $(this).removeClass("zfctn-show-item");
                        }
                    });
                    selection.forEach(function (e) {
                        resultList.find('[data-filter="' + e + '"]').each(function () {
                            if ($(this).hasClass("zfctn-hide-item")) {
                                $(this).removeClass("zfctn-hide-item");
                            }
                            $(this).addClass("zfctn-show-item");
                        });
                    });
                    thatParent.addClass("zfcui-btn-disabled");
                    if ($(this)
                        .closest(".zfctn-stage-height")
                        .find(".zfctn-button-wrapper .zfcui-btn-wrapper")
                        .hasClass("zfctn-btn-active")) {
                        $(this)
                            .closest(".zfctn-stage-height")
                            .find(".zfctn-button-wrapper .zfcui-btn-wrapper")
                            .removeClass("zfctn-btn-active");
                    }
                    $("html, body").animate({
                        scrollTop: resultList.offset().top,
                    }, 800);
                    if (resultList.find(".zfcgac-gallery-alternative-component").length > 0) {
                        zfcgac.init();
                    }
                });
                tileNavigation.find(".zfctn-tile-item").each(function () {
                    zfc.keyboardEnterToClick($(this));
                });
                tileNavigation
                    .find(".zfctn-tile-item")
                    .off("click.zfctn")
                    .on("click.zfctn", function () {
                    if (tileWrapper
                        .closest(".zfctn-tile-navigation")
                        .is(":not(.zfctn-tile-navigation-links)")) {
                        $(this).toggleClass("zfctn-item-active");
                        if ($(this)
                            .closest(".zfctn-stage-height")
                            .find(".zfctn-button-wrapper .zfcui-btn-wrapper")
                            .hasClass("zfctn-btn-active") == false) {
                            $(this)
                                .closest(".zfctn-stage-height")
                                .find(".zfctn-button-wrapper .zfcui-btn-wrapper")
                                .addClass("zfctn-btn-active");
                        }
                        button.parent().removeClass("zfcui-btn-disabled");
                        button.removeClass("zfcui-btn-disabled");
                    }
                });
                var previousScrollKey = tileWrapper.data("zfctn-scroll-key");
                if (previousScrollKey !== undefined && previousScrollKey !== null) {
                    zfUtils.offScroll(parseInt(previousScrollKey, 10));
                }
                var scrollKey = zfUtils.onScroll(function () {
                    if (zfc.elementPartlyInViewport(resultList[0])) {
                        buttonWrapper.removeClass("zfctn-button-wrapper-fixed");
                    }
                    else if (zfc.elementPartlyInViewport(stage[0])) {
                        buttonWrapper.addClass("zfctn-button-wrapper-fixed");
                    }
                });
                if (scrollKey !== null) {
                    tileWrapper.data("zfctn-scroll-key", scrollKey);
                }
            });
        }
        catch (err) {
            console.log("Initalization failed: zfctn.init() " + err.message);
        }
    }
}
try {
    zfUtils.onReady(zfctn.init);
}
catch (err) {
    console.log("Initalization failed: zfctn.init() " + err.message);
}
